export const COMMENT = 'COMMENT';
export const FOLLOW = 'FOLLOW';
export const LIKE = 'LIKE';
